<template>
  <user-list :type="2" />
</template>

<script>
import UserList from '@/components/user/List.vue'

export default {
  name: 'ViewOperatorList',

  components: { UserList }
}
</script>
